import { Field } from '@/layout/fields'

export class Relation extends Field {
  getLocalizedFilterColumn (column) {
    return column.key + '.brezel_name'
  }
}
